import { render, staticRenderFns } from "./SelectPlayersModal.vue?vue&type=template&id=18611d56&scoped=true&"
import script from "./SelectPlayersModal.vue?vue&type=script&lang=ts&"
export * from "./SelectPlayersModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPlayersModal.vue?vue&type=style&index=0&id=18611d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18611d56",
  null
  
)

export default component.exports